import { module } from 'stereomodularjs';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.el.addEventListener('click', () => {
            document.querySelector('#QSIFeedbackButton-btn').click()
        });
    }
}
